import { TextLinkWidget } from '@tableau/widgets';
import React from 'react';

import { DetailsTooltipStyles } from '~src/spacesPlatform/components/card/DetailsTooltipStyles';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';
import { HiddenUserStyles } from '~src/spacesPlatform/components/spaceComponents/SpacesStyles';
import { IUserInfo } from '~src/userManagement/users/models/IUserInfo';


export interface UserProps {
  label?: string;
  user: IUserInfo;
  urls: SpacesSiteUrls;
}

interface UserDisplayProps {
  displayName: string;
  url: string;
  displayAsText: boolean;
}

export interface HiddenUserProps {
  displayName: string;
}

export function HiddenUserDisplay(props: HiddenUserProps) {
  return (
    <span className={HiddenUserStyles.HiddenUserClassName}> { props.displayName } </span>
  );
}

export const UserDisplayTestId = 'user-display';
function UserDisplay(props: UserDisplayProps) {
  return (
    <span data-tb-test-id={UserDisplayTestId}>
      { props.displayAsText ?
        <HiddenUserDisplay displayName={props.displayName} /> :
        <TextLinkWidget href={props.url}>{props.displayName}</TextLinkWidget>
      }
    </span>
  );
}

export function User(props: UserProps) {
  if (!props.user || !props.user.displayName) {
    return null;
  }

  if (!props.label) {
    return (
      <UserDisplay displayName={props.user.displayName}
        url={props.urls.userUrl(props.user.username, props.user.domainName)}
      displayAsText={props.user.isHiddenInternalUser} />
    );
  }

  return (
    <>
      <dt className={DetailsTooltipStyles.DescriptionTerm}>{ props.label }</dt>
      <dd className={DetailsTooltipStyles.DescriptionDetails}>
        <UserDisplay displayName={props.user.displayName}
                      url={props.urls.userUrl(props.user.username, props.user.domainName)}
                      displayAsText={props.user.isHiddenInternalUser} />
      </dd>
    </>
  );
}
